import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=a2e75726"
import script from "./ProfilePhoto.vue?vue&type=script&lang=ts"
export * from "./ProfilePhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports